import React from 'react';

export const ToogleOff = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g mask="url(#mask0_674_54168)">
      <path
        d="M4.6665 12.5C3.55539 12.5 2.61095 12.1111 1.83317 11.3333C1.05539 10.5556 0.666504 9.61111 0.666504 8.5C0.666504 7.38889 1.05539 6.44444 1.83317 5.66667C2.61095 4.88889 3.55539 4.5 4.6665 4.5H11.3332C12.4443 4.5 13.3887 4.88889 14.1665 5.66667C14.9443 6.44444 15.3332 7.38889 15.3332 8.5C15.3332 9.61111 14.9443 10.5556 14.1665 11.3333C13.3887 12.1111 12.4443 12.5 11.3332 12.5H4.6665ZM4.6665 11.1667H11.3332C12.0665 11.1667 12.6943 10.9056 13.2165 10.3833C13.7387 9.86111 13.9998 9.23333 13.9998 8.5C13.9998 7.76667 13.7387 7.13889 13.2165 6.61667C12.6943 6.09444 12.0665 5.83333 11.3332 5.83333H4.6665C3.93317 5.83333 3.30539 6.09444 2.78317 6.61667C2.26095 7.13889 1.99984 7.76667 1.99984 8.5C1.99984 9.23333 2.26095 9.86111 2.78317 10.3833C3.30539 10.9056 3.93317 11.1667 4.6665 11.1667ZM4.6665 10.5C5.22206 10.5 5.69428 10.3056 6.08317 9.91667C6.47206 9.52778 6.6665 9.05556 6.6665 8.5C6.6665 7.94444 6.47206 7.47222 6.08317 7.08333C5.69428 6.69444 5.22206 6.5 4.6665 6.5C4.11095 6.5 3.63873 6.69444 3.24984 7.08333C2.86095 7.47222 2.6665 7.94444 2.6665 8.5C2.6665 9.05556 2.86095 9.52778 3.24984 9.91667C3.63873 10.3056 4.11095 10.5 4.6665 10.5Z"
        fill={color || '#7D7A9A'}
      />
    </g>
  </svg>
);
